module.exports = __webpack_public_path__ + "img/home_icon_3.87711239.png";